import _merge from 'lodash.merge';
import * as ActionTypes from './action-types.constants';

function getDefaultState() {
    const DEFAULT_STATE = {
        "expand": false
    }
    return DEFAULT_STATE;
}
const ShowMore = (state = getDefaultState(), action) => {
    let newState = {};

    const { type } = action;

    switch (type) {
        case ActionTypes.EXPAND:
            newState = {
                "expand": true
            }
            break;
        case ActionTypes.COLLAPSE:
            newState = {
                "expand": false
            }
            break;
        default:
            newState = state;
    }
    if (newState !== state) {
        newState = _merge(getDefaultState(), state, newState);
    }

    return newState;
}


export default ShowMore